export const COLORS = {
  blue_500: '#0072AB',
  white: '#ffffff',
  coolGrey_600: '#596373',
};
